<template>
  <div class="rounded-sm border flex flex-wrap items-center" :class="{ 'border-grey-200': !ac.is_selected, 'border-brand-1': ac.is_selected }">
    <div class="p-4 border-b md:border-b-0 md:border-r w-full md:w-2/3" :class="{ 'border-grey-200': !ac.is_selected, 'border-brand-1': ac.is_selected }">
      <input :id="id" v-model="ac.is_selected" type="checkbox" :disabled="disabled" class="hidden" />
      <div class="">
        <h3 class="text-xl mb-2 leading-tight block truncate font-700 mb-8">{{ $t('additionalCharges.beachPremiumSetTitle') }}</h3>
        <div class="flex flex-wrap my-8 sm:my-2" v-for="(option, i) in options" :key="i">
          <div class="w-full sm:w-8/12 font-700 sm:font-500">{{ option }}</div>
          <div class="w-full sm:w-4/12 sm:text-center flex sm:block">
            <div class="w-3/4 sm:hidden">
            </div>
            <span class="icon inline-block h-5 w-5 text-status-ok">
              <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check" class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"></path></svg>
            </span>
          </div>
        </div>
        <div class="text-sm text-grey-600">{{ $t('additionalCharges.beachPremiumSetAdditionalInfo') }}</div>
      </div>
    </div>
    
    <div class="p-2 w-full md:w-1/3">
      <template v-if="active">
        <div class="text-center text-lg text-grey-500">
          <s>$9,50 {{$t("additionalCharges.daily")}}</s>
        </div>
      </template>
      <div class="italic text-3xl text-center mb-4">{{ price }} {{$t("additionalCharges.daily")}}</div>
      <div class="text-center">
        <span class="button button--brand-3 outline uppercase cursor-pointer">
          <span v-if="ac.is_selected">{{$t("additionalCharges.removeBeachPremiumSet")}}</span>
          <span v-if="!ac.is_selected">{{$t("additionalCharges.addBeachPremiumSet")}}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
        name: 'BeachPremiumPackage',
        props: {
            id: String,
            ac: Object,
            disabled: Boolean
        },
        computed: {
            options() {
                return [
                    this.$t('additionalCharges.beachPremiumSetUsp1'),
                    this.$t('additionalCharges.beachPremiumSetUsp2'),
                    this.$t('additionalCharges.beachPremiumSetUsp3')
            ];
            },
            price() {
                return (this.AdditionalCharges[0] && this.AdditionalCharges[0].base_price)
                ? this.AdditionalCharges[0].base_price.amount_for_display
                : 0;
            },
            active() {
                  //return true if current date is between 1st of march and 31 of august
                  return new Date().getMonth() >= 2 && new Date().getMonth() <= 7
            },
    },
    data() {
        return {
            AdditionalCharges: [this.ac].filter(ac => ac.id === 23)
        };
}
};
</script>
